import { RawRadioGroup } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'

export type TransferScope = 'primary' | 'associated' | 'both'

const ALL_SCOPES: readonly TransferScope[] = ['primary', 'associated', 'both']

type Props = {
  value: TransferScope
  onChange: (scope: TransferScope) => void
  primaryLabel: string
  associatedLabel: string
  isPrimaryAvailable?: boolean
  isAssociatedAvailable?: boolean
}

export const TransferScopeSelector = ({
  value,
  onChange,
  primaryLabel,
  associatedLabel,
  isPrimaryAvailable = true,
  isAssociatedAvailable = true,
}: Props) => {
  const translate = useTranslate()

  const scopeLabels: Record<TransferScope, string> = {
    primary: primaryLabel,
    associated: associatedLabel,
    both: translate('transfer.scope.both'),
  }

  return (
    <RawRadioGroup
      id="transfer-scope"
      options={ALL_SCOPES}
      value={value}
      onChange={onChange}
      renderFn={(scope) => scopeLabels[scope]}
      keyFn={(scope) => scope}
      isDisabled={(scope) => {
        if (scope === 'primary') {
          return !isPrimaryAvailable
        }
        if (scope === 'associated') {
          return !isAssociatedAvailable
        }

        return !isPrimaryAvailable || !isAssociatedAvailable
      }}
    />
  )
}
